import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserApiService } from '../services';

@Pipe({ name: 'userData' })
export class UserDataPipe implements PipeTransform {
	private readonly userApiService = inject(UserApiService);

	/**
	 * Fetches the user object based on the id provided, if the user
	 * has been fetched previously, it will return the cache of the user
	 * instead to save on a call.
	 *
	 * @param id the id of the user to return
	 * @returns
	 */
	transform(id: string, useCache = true) {
		return this.userApiService.findById(id, useCache);
	}
}
